import axiosClient from "utils/api";
const URI = "/admin/language";

export const getLanguages = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Get All Languages:", error);
    throw error;
  }
};

export const deleteLanguage = async (payload) => {
  const URL = `${URI}/${payload.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Delete Language:", error);
    throw error;
  }
};

export const updateLanguage = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Update Language:", error);
    throw error;
  }
};

export const addLanguage = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Add Language:", error);
    throw error;
  }
};

export const updateDefaultLanguage = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/default/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Update Language:", error);
    throw error;
  }
};
